import { Order, OrderType } from "~/types/dropshipping";

export const PRODUCTS = ["PRODUCTS"];
export const ALIEXPRESS_PRODUCTS = ["ALIEXPRESS_PRODUCTS"];
export const IMPORT_LIST = ["IMPORT_LIST"];
export const ORDERS = ["ORDERS"];
export const DROPSHIPPING_SETTINGS = ["DROPSHIPPING_SETTINGS"];
export const MATCH_PRODUCTS = ["MATCH_PRODUCTS"];
export const BULK_CHECKOUT_SUMMARY = ["BULK_CHECKOUT_SUMMARY"];
export const ORDER_SHIPPING_ADDRESS = ["ORDER_SHIPPING_ADDRESS"];
export const CATEGORIES = ["CATEGORIES"];
export const LIVE_PRODUCTS = ["LIVE_PRODUCTS"];

export enum ImportListFilter {
  LOW_STOCK = "low_stock",
  OUT_STOCK = "out_of_stock",
}

export interface ImportListParams {
  page?: number;
  is_live?: boolean;
  filter?: ImportListFilter[] | string;
  search_term?: string;
}

export interface ILiveProductsParams {
  page?: number;
  filter?: ImportListFilter[] | string;
  search_term?: string;
}

export interface IPushToStoreParams {
  product_id: string;
  is_live: boolean;
  description: string;
  collections?: string[];
  tags?: string[];
}

export interface IOrdersParams {
  page?: number;
  order_type?: OrderType;
  search_term?: string;
}

export interface IOrdersList {
  data: Order[];
  page: number;
  total_pages: number;
}

export interface IAddressParams {
  first_name: string;
  last_name: string;
  line_1: string;
  line_2?: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  cpf?: string;
  passport_no?: string;
  phone?: string;
  order_id?: number;
}

export interface ICreateSampleOrderParams {
  quantity?: number;
  additive?: boolean;
  variant_id: number;
}

export interface IUpdateRetailPriceParams {
  retail_price_cents: number;
  variant_id: number;
}

export enum PricingRuleOperation {
  ADD = "add",
  MULTIPLY = "multiply",
  PERCENTAGE = "percentage",
}

export enum ProductOutOfStockAction {
  DO_NOTHING = "do_nothing",
  SET_AS_DRAFT = "set_as_draft",
  SET_QUANTITY_TO_ZERO = "set_quantity_to_zero",
}

export enum VariantOutOfStockAction {
  DO_NOTHING = "do_nothing",
  REMOVE_VARIANT = "remove_variant",
  SET_QUANTITY_TO_ZERO = "set_quantity_to_zero",
}

export enum VariantInventoryUpdateAction {
  DO_NOTHING = "do_nothing",
  UPDATE_STORE = "update_store",
}

export interface IDropshippingSettings {
  brand_name?: string;
  brand_logo?: number | string;
  invoice_store_name?: string;
  invoice_contact_email?: string;
  invoice_website?: string;
  invoice_logo?: string;
  invoice_body?: string;
  pricing_rule_operator: PricingRuleOperation;
  pricing_rule_operand: number;
  assign_cents?: number;
  product_out_of_stock_action: ProductOutOfStockAction;
  variant_out_of_stock_action: VariantOutOfStockAction;
  variant_inventory_update_action: VariantInventoryUpdateAction;
  language: string;
}

export interface IUpdateDropshippingSettings
  extends Omit<
    IDropshippingSettings,
    | "pricing_rule_operator"
    | "pricing_rule_operand"
    | "assign_cents"
    | "product_out_of_stock_action"
    | "variant_out_of_stock_action"
    | "variant_inventory_update_action"
    | "language"
  > {
  pricing_rule_operator?: PricingRuleOperation;
  pricing_rule_operand?: number;
  assign_cents?: number;
  product_out_of_stock_action?: ProductOutOfStockAction;
  variant_out_of_stock_action?: VariantOutOfStockAction;
  variant_inventory_update_action?: VariantInventoryUpdateAction;
  language?: string;
}

export interface IProductAssetPayload {
  id?: number;
  product: string | number;
  image?: string | number;
  order?: number;
}

export interface IProductVariantsPayload {
  product_id: string;
  variants: { id: number; is_active: boolean; imported_variant_id: number }[];
}

export interface IAliexpressProductShippingParams {
  ship_to_country: string;
  product_id: string;
  quantity: number;
  locale: string;
  currency?: string;
  sku_id: number | string;
  language?: string;
}

export interface IAliexpressProductShipping {
  shipping_options: IAliexpressProductShippingData;
  error_code?: number;
  message?: string;
}

export interface IAliexpressProductShippingData {
  base_price_cents: number;
  delivery_time: string;
}

export interface IAliexpressProductsById {
  ship_to_country?: string;
  target_currency?: string;
}
